export default ({ request }) => ({
    ecomHxPreOrderDetailScmSummaryListApi(data = {}) {
      return request({
        url: '/ecom/hx/pre/order/detail/scmSummaryList',
        method: 'POST',
        data,
      })
    },
    ecomHxPreOrderDetailScmPurchaseGenerateApi(data = {}) {
      return request({
        url: '/ecom/hx/pre/order/detail/scmPurchaseGenerate',
        method: 'POST',
        data,
      })
    },
    ecomHxPreOrderDetailScmSummaryDetailListApi(data = {}) {
      return request({
        url: '/ecom/hx/pre/order/detail/scmSummary/detail/list',
        method: 'POST',
        data,
      })
    }
  })
  